import { DataFilter } from "interfaces";

import { useGetDataInsight } from "./insights";

interface FrequentPatternSpec {
  transaction_column: string;
  item_column: string;
  min_support: number;
  grouping_columns?: string[];
  filters?: DataFilter.Filter[];
}

type FrequentPatternsData = {
  counts: number[];
  grouping: string[];
  "item-sets": string[][];
  "transaction-count": number;
}[];

export const useFetchFrequentPatterns = (
  fileId: string,
  spec: FrequentPatternSpec
) =>
  useGetDataInsight<FrequentPatternsData>({
    fileId,
    name: "data_frequent_itemsets",
    params: spec,
  });

interface AssociationRulesSpec {
  transaction_column: string;
  item_column: string;
  min_support: number;
  confidence_threshold: number;
  certainty_threshold: number;
  grouping_columns: string[];
  filters: DataFilter.Filter[];
}

interface AssociationRulesData {
  mapper: { [item: string]: string };
  rules: {
    antecedent: number[][];
    consequent: number[][];
    "ante-count": number[];
    "cons-count": number[];
    "joint-count": number[];
    confidence: number[];
    certainty: number[];
    "transaction-count": number;
    grouping: string[];
  }[];
}

export const useFetchAssociationRules = (
  fileId: string,
  spec: AssociationRulesSpec
) =>
  useGetDataInsight<AssociationRulesData>({
    fileId,
    name: "data_association_rules",
    params: spec,
  });
